import { comments } from '@/mocks/homeData';

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-xl md:text-3xl font-bold font-heading text-foreground-950">
            瓜友热评
          </h2>
          <p className="mt-3 text-sm text-foreground-600">
            来看看广大瓜友们都在聊什么
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5 max-w-4xl mx-auto">
          {comments.map((item, i) => (
            <div
              key={i}
              className="p-5 rounded-xl bg-background-50 border border-background-200/60"
            >
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-full overflow-hidden bg-background-200 flex-shrink-0">
                  <img
                    src={item.avatar}
                    alt={item.name}
                    className="w-full h-full object-cover"
                    loading="lazy"
                  />
                </div>
                <div>
                  <p className="text-sm font-medium text-foreground-800 whitespace-nowrap">
                    {item.name}
                  </p>
                  <p className="text-xs text-foreground-500 whitespace-nowrap">
                    {item.time}
                  </p>
                </div>
              </div>
              <p className="text-sm text-foreground-700 leading-relaxed mb-3">
                {item.content}
              </p>
              <div className="flex items-center gap-1 text-xs text-foreground-500">
                <i className="ri-thumb-up-line"></i>
                <span>{item.likes.toLocaleString()}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}